import { http } from "./http";
import type { IgDmVerifyStart, IgDmVerifyStatus } from "../types/fans";
import type { SignupIdentity, SignupIgClaimStatus, SignupIgDmStart, SignupIgOauth } from "../types/auth";

// A sign-up's claim token rides in a header, never in a URL.
const claimHeader = (claim: string) => ({ headers: { "X-Rq-Claim": claim } });

// "Continue with Instagram" (THE IG GATE's verified handle). The server owns
// the round trip; the client only asks for the URL to send the talent to.
export const instagramApi = {
  /** Where to send the talent to sign in to Instagram. 503 while the feature is off. */
  oauthUrl: (fields: { client?: "app" | "web"; to?: "qr" | "profile" }) =>
    http.post<{ url?: string }>("/instagram/oauth-url", fields),
  /** "Verify with a DM", the backup for a personal account (1.5.3): a one-time
      ig.me link. 503 { msg: "not_available" } while it's off for this talent. */
  startDmVerify: () => http.post<IgDmVerifyStart>("/instagram/dm-verify"),
  /** pending | verified | taken | expired — polled while the talent is in Instagram. */
  dmVerifyStatus: (sessionId: string) =>
    http.get<IgDmVerifyStatus>(`/instagram/dm-verify/${encodeURIComponent(sessionId)}`),

  // ── Sign-up (build 54): no account yet. Who it is = the Google / Apple
  // token from the sign-in screen; the proof waits on a claim register attaches.
  /** Instagram's sign-in for a sign-up. 503 while the step is off, 409 if the account exists. */
  signupOauthUrl: (body: SignupIdentity & { client?: "app" | "web"; claim?: string }) =>
    http.post<SignupIgOauth>("/instagram/signup/oauth-url", body),
  /** "Say hi on Instagram", for a sign-up. */
  signupDmStart: (body: SignupIdentity & { claim?: string }) => http.post<SignupIgDmStart>("/instagram/signup/dm-verify", body),
  /** What Instagram's sign-in proved (read when the sign-up comes back from Instagram). */
  signupClaim: (claim: string) => http.get<SignupIgClaimStatus>("/instagram/signup/claim", claimHeader(claim)),
  /** pending | verified | taken | expired — polled while the sign-up is in Instagram. */
  signupDmStatus: (claim: string, sessionId: string) =>
    http.get<IgDmVerifyStatus>(`/instagram/signup/dm-verify/${encodeURIComponent(sessionId)}`, claimHeader(claim)),
};
